import lowerFirst from 'lodash/lowerFirst'

import type { RevealQuotaDimension } from '@albacross/types'

export type ApiMeter = {
  label: string
  description: string
}

export type RevealMeterId = RevealQuotaDimension | 'uniqueIdentifiedCompanies'

export const REVEAL_METERS = {
  requests: {
    label: 'Requests',
    description:
      'Every lookup this month, whether or not a company was found. Lookups are refused once this reaches the limit plus any temporary credits.',
  },
  identified: {
    label: 'Identified requests',
    description:
      'Lookups this month that returned a company. The same IP looked up twice counts twice. Refused at the limit, like requests.',
  },
  uniqueIdentifiedIps: {
    label: 'Unique identified IPs',
    description:
      'Distinct IP addresses that returned a company this month. Refused at the limit. Self-serve API plan tiers set this limit; enterprise limits are set by hand on the API tab. The customer sees it as "Unique Visitors" on both the API Overview tab and the Usage chart.',
  },
  uniqueIdentifiedCompanies: {
    label: 'Unique identified companies',
    description:
      'Distinct companies returned this month, told apart by website or else name and country. Several IPs usually resolve to one company, so it sits below unique IPs. No limit exists and the customer does not see this number.',
  },
} satisfies Record<RevealMeterId, ApiMeter>

export const ENRICH_METERS = {
  requests: {
    label: 'Requests',
    description:
      'Every domain lookup this month, whether or not a company was found. Lookups are refused once this reaches the limit.',
  },
} satisfies Record<string, ApiMeter>

export const DOMAIN_ALLOWLIST_DESCRIPTION =
  'Websites allowed to call the API with the public key, matched against the Referer header. The secret key is not restricted by it.'

export const revealMeterLabel = (id: RevealMeterId) => `Reveal API ${lowerFirst(REVEAL_METERS[id].label)}`

export const revealLimitLabel = (id: RevealQuotaDimension) => `${revealMeterLabel(id)} limit`

export const enrichMeterLabel = (id: keyof typeof ENRICH_METERS) => `Enrich API ${lowerFirst(ENRICH_METERS[id].label)}`
